import { Trascodifica } from "./trascodifica";

export class BloccoImmobileSearch {
	idStato: number;
	riferimento: string;
	stati: Array<Trascodifica>;
	numeroPagina: number;
	numeroElementi: number;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/blocco-immobile-search.ts